import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function StaticBody() {
	return (
		<>
			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_warranties">
					<strong>WARRANTIES.</strong>
					The obligation of the GUARANTOR is presumed valid and binding until Philippine courts say that the
					Agreement and/or this Guaranty is void, invalid, or unenforceable. Also, the GUARANTOR only
					guarantees payment of the Loan and interest but not any future debts of the BORROWER.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_right">
					<strong>RIGHT TO COLLECT.</strong>
					If the GUARANTOR pays for the Loan and interest, the GUARANTOR can demand reimbursement from the
					BORROWER for the full amount of the Loan and the interest, legal interest on the amount paid to the
					LENDER, and other costs and expenses that the GUARANTOR incurred to pay the LENDER.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_termination">
					<strong>TERMINATION.</strong>
					This Guaranty shall only end if the BORROWER fully (a) pays the LENDER according to the Agreement or
					(b) reimburses the GUARANTOR according to the paragraph above.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_compromise">
					<strong>COMPROMISE.</strong>
					If the LENDER and the BORROWER enter into a compromise, the GUARANTOR can benefit from, but cannot
					be harmed by, that compromise. On the other hand, if the BORROWER and the GUARANTOR enter into a
					compromise, the LENDER can benefit from, but cannot be harmed by, that compromise.
				</Trans>
			</p>
			<p className="page-break"></p>
			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_entire">
					<strong>ENTIRE AGREEMENT.</strong>
					All the agreed terms and conditions between the GUARANTOR and the BORROWER are in this Guaranty.
					References to the Loan shall be based on the Loan Agreement Promissory Note to which this Guaranty
					is attached. If the PARTIES want to make changes to this Guaranty, they must write down those
					changes and sign that document. When both PARTIES have signed that document, the agreed changes
					automatically change and become part of this Guaranty.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_governing_law">
					<strong>GOVERNING LAW.</strong>
					Philippine law governs this Agreement.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_venue">
					<strong>VENUE AND PLACE OF PAYMENT.</strong>
					The PARTIES agree that if there is a problem or disagreement about this Guaranty, they will try
					their best to discuss the problem and work together to fix it. But if they cannot fix the problem
					and the BORROWER and/or the GUARANTOR must go to court, they can only file a case with the courts
					that have jurisdiction over the place where the GUARANTOR lives.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_borrower.static_body_venue_bottom">
					The PARTIES have agreed that neither of them can go to any other court.
				</Trans>
			</p>
		</>
	);
}

export default hot(module)(withTranslation()(StaticBody));
